// Event lifecycle state — pure logic, shared by the map layer.
// Kept independent of any map library so the cartographic layer stays swappable.

export const EVENT_STATES = {
  live: { key: "live", label: "Live", color: "#EF4444" },
  active: { key: "active", label: "Active", color: "#2563EB" },
  scheduled: { key: "scheduled", label: "Scheduled", color: "#F59E0B" },
  expired: { key: "expired", label: "Ended", color: "#94A3B8" },
};

export const STATE_ORDER = ["live", "active", "scheduled", "expired"];

const past = (v) => v && new Date(v).getTime() < Date.now();
const future = (v) => v && new Date(v).getTime() > Date.now();

// Derive a single UI state from a raw backend event.
export function computeEventState(be = {}) {
  if (be.is_live) return "live";
  const ended =
    be.status === "ended" ||
    be.lifecycle_status === "ended" ||
    be.visibility_status === "hidden" ||
    !!be.resolved_at ||
    !!be.archived_at ||
    past(be.ends_at) ||
    past(be.expires_at) ||
    past(be.expired_at);
  if (ended) return "expired";
  if (future(be.starts_at || be.start_time)) return "scheduled";
  return "active";
}

export const stateColor = (s) => (EVENT_STATES[s] || EVENT_STATES.active).color;
export const stateLabel = (s) => (EVENT_STATES[s] || EVENT_STATES.active).label;
